module.exports = __webpack_public_path__ + "static/burg1-f70ad71fa9e8ddaec5f559ff339db341.jpg";